module.exports = __webpack_public_path__ + "img/ic_camera_add.ecca77ba.svg";